import { SelectProps } from 'antd'
import { Select } from 'components/atoms'
import { SEARCH_DOCTOR_QUERY, SEARCH_QUERY_URL } from 'constants/query'
import { transformData, useQuerySearch } from 'hooks'
import { IClinicRoom } from 'interfaces/clinic/IClinicRoom'
import { useEffect, useState } from 'react'
import { useDoctorService } from 'services/useDoctorService'

interface IProps extends SelectProps<any, any> {
  title?: string
  placeholder?: string
  preventInput?: boolean
  required?: boolean
}

const SelectDoctor = (props: IProps) => {
  const { searchDoctor } = useDoctorService()
  const { transformArrayObject } = transformData()
  const [doctors, setDoctors] = useState([] as any)
  const { items, handleOnSearch: searchListClinic } =
    useQuerySearch<IClinicRoom>(SEARCH_QUERY_URL.ClinicRoom)
  useEffect(() => {
    searchListClinic({})
  }, [])
  const handleOnSearch = (key?: string) => {
    const query = { ...SEARCH_DOCTOR_QUERY, query: { name: key }, limit: 50 }
    searchDoctor(query).then((res) => {
      const options = transformArrayObject(res.data?.data, {
        value: 'id',
        label: 'full_name',
        status: 'status'
      })
      const filteredDoctors = options.filter(
        (doctor: any) => doctor.status === 2
      )
      const matchingDoctors = filteredDoctors.filter((doctor: any) =>
        items.some((item) => item.doctor_id === doctor.value)
      )
      const assignedDoctor = filteredDoctors.map((doctor: any) => ({
        ...doctor,
        disabled: matchingDoctors.some(
          (match: any) => match.value === doctor.value
        )
      }))
      setDoctors(assignedDoctor)
    })
  }

  return (
    <>
      <Select
        title="doctor"
        showArrow
        showSearch
        placeholder="please-choose-info"
        options={doctors}
        filterOption={false}
        onSearch={handleOnSearch}
        onFocus={() => handleOnSearch()}
        {...props}
      />
    </>
  )
}

export default SelectDoctor
